<template>
  <v-app>
    <!--
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <v-list>
        <v-list-tile v-for="(item, i) in menuitems" :key="i" :to="item.routerlink">
          <v-list-tile-action>
            <v-icon v-html="item.icon" :to="item.routerlink"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title" :to="item.routerlink"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>-->

    <v-app-bar app :clipped-left="clipped">
      <!--<v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>-->
      <!--<router-link to="/">-->
      <!-- <v-toolbar-title v-text="title"></v-toolbar-title> -->
      <!--</router-link>-->
      <b>BEVENUTO {{this.$session.get("name")}}</b>
      <v-spacer></v-spacer>
      <!--<v-btn v-if="loginEffettuato" flat v-on:click="nuovoRapportino()">INSERIMENTO RAPPORTINO</v-btn>-->
      <v-btn v-if="loginEffettuato()" text v-on:click="nuovoFoglioOre()">FOGLIO ORE</v-btn>
      <v-btn v-if="loginEffettuato()" color="teal" text value="logout" v-on:click="logout()">
        <span>Logout {{this.$session.get("name")}}</span>
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <NotificationView></NotificationView>
        <router-view></router-view>
        <DialogOperationRunning
          name="dialogOperationRunning"
          v-model="progressMessageEnable"
          :dialogTitle="operationRunningTitle"
          :dialogMessage="progressMessage"
          :loading="progressLoading"
        />
        <DialogError
          v-model="errorMessageEnable"
          name="dialogError"
          :dialogTitle="errorDialogTitle"
          :dialogMessage="errorMessage"
        />
      </v-container>
    </v-content>
    <v-footer app padless>
      <v-flex class="text-center caption grey--text py-1" tag="div">
        Sviluppato da
        <a
          href="https://www.effecitech.com"
          target="_blank"
          rel="noopener"
        >Effecitech</a>
      </v-flex>
    </v-footer>
  </v-app>
</template>

<script>
/* eslint-disable */
import { store } from "./store/store";
import NotificationView from "./views/NotificationView";
import MixingCommonComp from "./mixin/MixingCommonComp";

export default {
  mixins: [MixingCommonComp],
  data() {
    return {
      clipped: false,
      menuitems: [
        {
          icon: "local_printshop",
          title: "Home",
          routerlink: "/home"
        }
      ],
      drawer: false,
      fixed: true,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "VITECH"
    };
  },
  components: {
    NotificationView
  },
  methods: {
    nuovoFoglioOre() {
      this.$router.push({ path: "/foglioOre" });
    },
    nuovoRapportino() {
      this.$router.push({ path: "/nuovoRapportino" });
    },
    logout() {
      this.$session.clear();
      this.$session.destroy();
      this.$router.push({ path: "/Login/" });
    },
    callBackFunction() {
      console.log("callBackFunction");
    }
  },
  created: function() {
    document.title = this.$windowTitle;
    document.addEventListener("backbutton", this.callBackFunction, false);
    //store.dispatch("generateLottoInterno");
    // document.head.querySelector('meta[name=description]').content = 'New Description'
  } /*,
  mounted() {
    document.addEventListener("backbutton",this.callBackFunction, false)
  },
  beforeDestroy(){
    document.removeEventListener("backbutton",this.callBackFunction)
  }*/,
  name: "App"
};
</script>
